import { IconWrapper } from '../runtime';
export default IconWrapper('comment', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M5.75024 5.74976H10.2502M3.25 12.2629C2.42157 12.2629 1.75 11.5914 1.75 10.7629L1.75024 3.24976C1.75024 2.42133 2.42181 1.74976 3.25024 1.74976H12.7502C13.5787 1.74976 14.2502 2.42133 14.2502 3.24976L14.25 10.7629C14.25 11.5914 13.5784 12.2629 12.75 12.2629H8.7822L6.26073 14.8168C6.0723 15.0077 5.74725 14.8742 5.74725 14.606V12.2629H3.25Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});